import { MenuItem } from 'generated/graphql';
import { addBackslashIfMissing } from 'utils/addBackSlashIfMissing';
import { useOrganisationPersonalWebshop } from './useOrganisationPersonalWebshop';

export default function useMenuSlugParser() {
    const { isConsultantRoute, baseUrl } = useOrganisationPersonalWebshop();
    const parseSlug = (menuItem: MenuItem | string) => {
        const slug = typeof menuItem === 'string' ? menuItem : menuItem.slug;
        if (slug.startsWith('http')) {
            return slug;
        }
        // We need to add in "baseUrl" after the string "/sv" or at the very start
        const cleanSlug = addBackslashIfMissing(slug);
        const noSvSlug = cleanSlug.replace('/sv', '');
        const finalSlug = isConsultantRoute
            ? `${baseUrl}${noSvSlug}`
            : `${addBackslashIfMissing(slug)}`;

        return finalSlug;
    };

    return { parseSlug };
}
